var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.pageBlocks),function({ component, props, type, title, nobody },index){return _c(component,_vm._b({key:`block-${index}`,tag:"component",attrs:{"title":title,"nobody":nobody,"block-index":index,"type":type}},'component',{ ...props },false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }